export default __webpack_public_path__ + "static/us-3460b72b21aa299ed6cf297e7cc62121.jpg";